import React from 'react';
import { HelpCircle } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    q: '¿Tengo que lavar toda la ropa de la casa?',
    a: 'No, solo lo que tocó la cabeza en las últimas 24 horas. El manual te dice exactamente qué.'
  }, {
    q: '¿Es seguro para niños pequeños?',
    a: 'Sí, es un método mecánico y natural, sin pesticidas.'
  }, {
    q: '¿Cuánto tiempo toma cada día?',
    a: 'El día 1 toma una hora; los días siguientes solo 10 minutos de revisión.'
  }, {
    q: '¿Tengo que comprar herramientas caras?',
    a: 'Solo un peine metálico específico que te costará menos de $15 en Amazon.'
  }];
  return <section className="py-20 px-4 bg-slate-50" data-id="element-39">
      <div className="max-w-3xl mx-auto" data-id="element-40">
        <div className="text-center mb-12" data-id="element-41">
          <HelpCircle className="w-12 h-12 text-teal-600 mx-auto mb-4" data-id="element-42" />
          <h2 className="text-3xl font-extrabold text-slate-900" data-id="element-43">
            Preguntas Frecuentes
          </h2>
        </div>

        <div className="space-y-4" data-id="element-44">
          {faqs.map((faq, idx) => <div key={idx} className="bg-white p-6 rounded-xl border border-slate-200 shadow-sm" data-id="element-45">
              <h4 className="font-bold text-lg text-slate-900 mb-2" data-id="element-46">{faq.q}</h4>
              <p className="text-slate-600" data-id="element-47">{faq.a}</p>
            </div>)}
        </div>
      </div>
    </section>;
}